import styled from 'styled-components'

import { SettingsTileUnstyled } from 'Components/Settings/SettingsTile/unstyled'

export const SettingsTile = styled(SettingsTileUnstyled)`
  display: block;
  height: 105px;
  width: 100%;
  max-width: 260px;
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.iron};
  border-radius: 4px;
  padding: 25px;
  margin: 0 25px 25px 0;

  & > div:first-child {
    color: ${props => props.theme.colors.oxfordBlue};
    font-size: ${props => props.theme.fontSizes.settings.settingsTile.label};
    font-family: ${props => props.theme.fonts.robotoRegular};
  }

  a,
  button {
    position: absolute;
    text-decoration: none !important;
    right: 14px;
    bottom: 14px;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Settings/SettingsTile/index.js